module.exports = __webpack_public_path__ + "img/kefu1.1c5db924.png";